var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"body"},[_c('div',[_c('themed-table',{attrs:{"headers":this.bedManagerService.selectedJob.headers,"data":_vm.transformedData,"sortingEnabled":true,"localSorting":true,"filteringEnabled":false,"paginationEnabled":false},on:{"searchChange":(event) => {},"sortingChange":(event) => {
            _vm.localSorting = event;
          }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }